"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _Modal = _interopRequireDefault(require("@mui/material/Modal"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _theme = require("../../theme");
var _Button = _interopRequireDefault(require("../Button"));
var _Text = _interopRequireDefault(require("../Text"));
var _ModalContent = _interopRequireDefault(require("../ModalContent"));
var _ModalFilePreview = _interopRequireDefault(require("../ModalFilePreview"));
var _pdf = _interopRequireDefault(require("../../../src/assets/pdf.png"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable arrow-body-style */
var DropZoneModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(DropZoneModal, _Component);
  function DropZoneModal() {
    var _this;
    (0, _classCallCheck2["default"])(this, DropZoneModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, DropZoneModal, [].concat(args)), _this.state = {
      showContactModal: false,
      files: [],
      fileName: '',
      showDropzone: true,
      thumbnails: []
    }, _this._chooseDocument = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(files) {
        var duplicate, file, reader;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (files[1] !== null) {
                files = new Array(files[0]);
              }
              duplicate = _this.state.files.some(function (file) {
                return file.name === files[0].name;
              });
              file = files[0];
              reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function () {
                if (!duplicate) {
                  // Set thumbnail image to pdf.png if they type is pdf
                  var thumbnailImage = reader.result;
                  if (file.type === 'application/pdf') {
                    thumbnailImage = _pdf["default"];
                  }
                  _this.setState({
                    fileName: files[0].name,
                    files: [].concat((0, _toConsumableArray2["default"])(_this.state.files), (0, _toConsumableArray2["default"])(files)),
                    thumbnails: [].concat((0, _toConsumableArray2["default"])(_this.state.thumbnails), [{
                      name: files[0].name,
                      image: thumbnailImage
                    }])
                  });
                } else {
                  // this.props.dispatch(notifier.displayError({ verbiage: 'File already selected, please select a different file.' }));
                  alert('File already selected, please select a different file.');
                }
              };
              _context.next = 8;
              return _this.setState({
                showDropzone: _this.state.files.length < _this.props.maxItems
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _this._fileName = function (file) {
      var filename = null;
      file.name.length > 25 ? filename = "".concat(file.name.substr(0, 11), "...").concat(file.name.substr(-11)) : filename = file.name;
      return filename;
    }, _this._removeDocument = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(name) {
        var fileArray, thumbnailArray;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              fileArray = _this.state.files.filter(function (file) {
                return file.name !== name;
              });
              thumbnailArray = _this.state.thumbnails.filter(function (thumb) {
                return thumb.name !== name;
              });
              _context2.next = 4;
              return _this.setState({
                files: fileArray,
                thumbnails: thumbnailArray,
                showDropzone: true
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }(), _this._submitDocument = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var submit;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(_this.state.files.length > 0)) {
              _context3.next = 6;
              break;
            }
            _context3.next = 3;
            return _this.props.collectFiles(_this.state.files, _this.state.thumbnails);
          case 3:
            submit = _context3.sent;
            _this.props.hideModal();
            return _context3.abrupt("return", submit);
          case 6:
            return _context3.abrupt("return", null);
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(DropZoneModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        showModal = _this$props.showModal,
        hideModal = _this$props.hideModal,
        title = _this$props.title,
        acceptedFiles = _this$props.acceptedFiles,
        id = _this$props.id,
        testid = _this$props.testid;
      var showDropzone = this.state.showDropzone;
      var styles = {
        btn: {
          width: 'fit-content',
          marginLeft: 'auto'
        },
        closeModalIcon: {
          cursor: 'pointer',
          display: 'inline',
          marginTop: '5px',
          fontSize: '22px',
          "float": 'right',
          color: _theme.colors.mainTextGrey
        },
        titleIconWrapper: {
          display: 'block',
          width: '100%',
          paddingBottom: '15px',
          verticalAlign: 'center'
        },
        cardStyle: {
          backgroundColor: _theme.colors.lightBlue,
          boxShadow: 'none',
          padding: '20px',
          border: "2px dotted ".concat(_theme.colors.mediumBlue),
          borderRadius: '8px',
          textAlign: 'center',
          color: _theme.colors.mediumBlue
        },
        cardDisabled: {
          backgroundColor: _theme.colors.lightGrey,
          boxShadow: 'none',
          padding: '20px',
          border: "2px dotted ".concat(_theme.colors.mediumLightGrey),
          borderRadius: '8px',
          color: _theme.colors.mediumLightGrey
        },
        previewWrapper: {
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-around',
          alignItems: 'center',
          marginBottom: '10px',
          backgroundColor: _theme.colors.lightGrey,
          boxShadow: 'none',
          padding: '5px',
          borderRadius: '8px'
        },
        fileTitle: {
          maxWidth: '300px',
          wordBreak: 'break-all'
        },
        thumbnail: {
          maxWidth: 260,
          paddingBottom: 25,
          paddingTop: 35
        }
      };
      return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
        open: showModal,
        onClose: hideModal,
        style: {
          overflow: 'auto',
          'WebkitOverflowScrolling': 'touch'
        },
        disableEscapeKeyDown: true,
        disableEnforceFocus: true
      }, /*#__PURE__*/_react["default"].createElement(_ModalContent["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.titleIconWrapper
      }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        style: styles.closeModalIcon,
        onClick: hideModal
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        align: "center",
        bold: true,
        mediumLarge: true,
        display: "inline-block",
        margin: "0"
      }, title)), this.state.files.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.previewWrapper
      }, this.state.files.map(function (file) {
        var fileName = _this2._fileName(file);
        return /*#__PURE__*/_react["default"].createElement(_ModalFilePreview["default"], null, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
          style: styles.closeModalIcon,
          onClick: function onClick() {
            return _this2._removeDocument(file.name);
          }
        }), _this2.state.thumbnails.map(function (thumb) {
          if (file.name === thumb.name) {
            return /*#__PURE__*/_react["default"].createElement("img", {
              key: thumb,
              alt: "Thumbnails",
              src: thumb.image,
              style: styles.thumbnail
            });
          }
          return null;
        }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          align: "center",
          bold: true,
          mediumLarge: true,
          display: "block",
          margin: "0",
          customStyle: {
            maxWidth: '300px',
            width: '100%'
          }
        }, fileName));
      }))), this.state.showDropzone && /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
        onDrop: function onDrop(files) {
          return _this2._chooseDocument(files);
        },
        accept: acceptedFiles || "image/jpeg, image/jpg, image/png, video/mp4"
      }, function (_ref4) {
        var getRootProps = _ref4.getRootProps,
          getInputProps = _ref4.getInputProps;
        return /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, getRootProps(), {
          style: !showDropzone ? styles.cardDisabled : styles.cardStyle
        }), /*#__PURE__*/_react["default"].createElement("input", getInputProps()), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          id: id || testid,
          color: "skyBlue",
          margin: "20px 0",
          small: true,
          align: "center"
        }, _i18n["default"].t(_tokens["default"].labels.employees.dragAndDropImagesHere))));
      }), acceptedFiles && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        margin: "10px 0 0",
        align: "center",
        tiny: true
      }, acceptedFiles), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        disabled: this.state.files.length === 0,
        onClick: this._submitDocument,
        color: "primary",
        customStyle: styles.btn,
        marginTop: 5
      }, "Submit")));
    }
  }]);
  return DropZoneModal;
}(_react.Component);
var _default = exports["default"] = DropZoneModal;